import { Button } from "@carbon/react";

import { TextInput } from "../../ui";
import { FormContainer } from "../../components";
import switchAppLogo from "../../assets/icons/switchapp-logo.svg";
import { Link } from "react-router-dom";

export const View = () => {
  return (
    <div className="auth-page--container flex-container col justify-content--center align-items--center">
      <div>
        <div className="logo-container flex-container justify-content--start">
          <img src={switchAppLogo} alt="logo" />
        </div>

        <FormContainer>
          <div className="form-container flex-container col">
            <div className="form-container__header font-ctm--bold">
              <h3>Sign in to your account</h3>
            </div>

            <div className="form-container__body">
              <div className="form-container__body__input-container">
                <TextInput label="Email" />
                <TextInput label="Password" />

                <div className="flex-container col">
                  <p className="align-self--end switchapp-small">
                    <Link to={"/forgot-password"}>Forgot Password?</Link>
                  </p>
                </div>
              </div>

              <div className="flex-container buttons-container">
                <Button className="flex-box switchapp-themed">Sign In</Button>
              </div>
            </div>
          </div>

          <div className="form-container__footer">
            <p className="switchapp-small">
              Don't have an account? <Link to={"/signup"}>Sign up</Link>
            </p>
          </div>
        </FormContainer>
      </div>
    </div>
  );
};
